import React, { useRef } from 'react';
import Papa from 'papaparse';
import { Button } from 'rsuite';

function toCamelCase(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
}

const requiredFields = [
  'location',
  'round',
  'instrument',
  'method',
  'parameter',
  'labs',
  'material',
  'size',
  'arv',
  'measuredValue'
];

const numericFields = ['labs', 'arv', 'measuredValue'];

export async function parseCSVFile(file) {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const validRows = [];
        const invalidRows = [];

        results.data.forEach((row, index) => {
          const cleanRow = Object.fromEntries(
            Object.entries(row).map(([k, v]) => [toCamelCase(k.trim()), v?.trim?.() || v])
          );

          if (Object.values(cleanRow).every((val) => val === '')) return;

          const missing = requiredFields.filter(
            (field) => !cleanRow[field] || cleanRow[field] === ''
          );

          numericFields.forEach((field) => {
            if (cleanRow[field] !== undefined && cleanRow[field] !== '') {
              const num = Number(cleanRow[field]);
              if (isNaN(num)) {
                missing.push(`${field} (must be number)`);
              } else {
                cleanRow[field] = num;
              }
            }
          });

          if (missing.length > 0) {
            invalidRows.push({
              __csvIndex: index,
              rowNumber: index + 2,
              missing
            });
          } else {
            validRows.push({
              ...cleanRow,
              __csvIndex: index,
              rowNumber: index + 2
            });
          }
        });

        resolve({ validRows, invalidRows });
      },
      error: (error) => reject(error)
    });
  });
}

const CSVImportButton = ({ loading, title, startIcon, handleFileImport }) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <Button
        appearance="primary"
        loading={loading}
        onClick={handleClick}
        style={{ minWidth: '120px' }}
        startIcon={startIcon}
      >
        {title}
      </Button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv"
        style={{ display: 'none' }}
        onChange={handleFileImport}
      />
    </>
  );
};

export default CSVImportButton;
